<template>
  <div
    ref="site-nav-full"
    :class="['site-nav-full', { open }]"
    :style="{ left: open ? '0' : `-${width}px` }"
  >
    <i
      class="fa fa-chevron-right toggle"
      @click="$emit('toggled')"
    />

    <div class="content">
      <div class="header-icons">
        <a
          href="https://help.yourstake.org/knowledge"
          title="Click to visit our help center"
          target="_blank"
          rel="noreferrer noopener"
        >
          <i class="fa fa-question-circle" />
        </a>
      </div>

      <div>
        <div class="client-logo">
          <ClientLogo :advisor-data="advisor" />
        </div>
        <UserStatus :advisor="advisor" />
      </div>

      <div class="menu">
        <NavMenuSection
          v-for="section in links"
          :key="section.name"
          :section="section"
          :features="features"
          :active="active"
          :expanded-section="expandedSection"
          @expand="() => expandedSection = section.name"
        />
      </div>
    </div>

    <footer><YourStakeLogo /></footer>
  </div>
</template>


<script>
import UserStatus from './UserStatus.vue';
import NavMenuSection from './NavMenuSection.vue';
import ClientLogo from '@frontend/ui/components/ClientLogo.vue';
import YourStakeLogo from '@frontend/ui/components/YourStakeLogo.vue';

export default {
  name: 'SiteNavFull',
  components: { UserStatus, NavMenuSection, ClientLogo, YourStakeLogo },
  props: ['open', 'links', 'active', 'advisor', 'features'],
  data() {
    return {
      width: 500,
      expandedSection: '',
    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {
    this.width = this.$refs['site-nav-full'].offsetWidth;
    this.$emit('sized', this.width);
  },
  updated() {},
  methods: {

  },
};
</script>


<style scoped>
  .site-nav-full {
    z-index: 10000;
    position: fixed;
    top: 0; left: 0; bottom: 0;
    transition: left 0.5s ease;

    padding: 1em;
    background-color: #f2f2f2;
    border-right: 1px solid #f5f5f5;
    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.2);

    font-size: 16px !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .toggle {
    position: absolute;
    top: 12px;
    right: -26px;
    transition: all 0.5s ease;

    font-size: 28px;
    color: #3a66ac;
    opacity: 0.5;
    cursor: pointer;
  }

  .toggle:hover {
    opacity: 1;
  }

  .site-nav-full.open .toggle {
    right: 8px;
    transform: rotateY(180deg);
  }

  .header-icons {
    display: flex;
    font-size: 18px;
  }

  .header-icons i:hover {
    cursor: pointer;
  }

  .header-icons a {
    color: gray;
  }

  .content, .menu {
    display: flex;
    flex-direction: column;
  }

  .content {
    gap: 2em;
  }

  .menu {
    gap: 0.5em;
  }

  .client-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.25em;
  }
</style>
